import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';
import { tasksService } from '../../../../services/tasks';

import { createLogger } from '../../../../utils/logger';
const logger = createLogger('EndOfLifeWishesIntro');

export const EndOfLifeWishesIntroScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleYes = () => {
    navigation.navigate('EndOfLifeWishesInput');
  };

  const handleNo = async () => {
    try {
      await tasksService.completeTask('end_of_life_wishes');
      (navigation as any).navigate('CarePreferences', { screen: 'CarePreferencesChecklist', params: { refreshKey: Date.now() } });
    } catch (error) {
      logger.error('Error completing end-of-life wishes task:', error);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
          <Image source={require('../../../../assets/icons/back.png')} style={[styles.backIcon, { tintColor: '#fff' }]} />
        </TouchableOpacity>
      </View>

      <View style={styles.topSection}>
        <Image source={require('../../../../assets/icons/keyimage.png')} style={styles.backgroundKey} />
        <Image source={require('../../../../assets/logo.png')} style={styles.logo} resizeMode="contain" />
        <Text style={styles.title}>End-of-Life Treatment Wishes</Text>
        <Text style={styles.subtitle}>
          Document your preferences for medical treatments at end of life, including ventilators, feeding tubes, pain management, and comfort care.
        </Text>
      </View>

      <View style={styles.contentContainer}>
        <Text style={styles.question}>Would you like to document your end-of-life treatment preferences?</Text>

        <View style={styles.buttonContainer}>
          <TouchableOpacity style={styles.yesButton} onPress={handleYes}>
            <Text style={styles.yesButtonText}>Yes, I'll document them</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.noButton} onPress={handleNo}>
            <Text style={styles.noButtonText}>Skip for now</Text>
          </TouchableOpacity>
        </View>
      </View>

      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#29BFC0' },
  header: { flexDirection: 'row', alignItems: 'center', padding: ms(15), paddingTop: ms(25), position: 'relative' },
  backButton: { position: 'absolute', left: ms(50), padding: ms(15), paddingTop: ms(50), zIndex: 1 },
  backIcon: { width: ms(32, 0.3), height: ms(32, 0.3), tintColor: '#fff' },
  topSection: { alignItems: 'center', paddingVertical: ms(20), paddingHorizontal: ms(20) },
  backgroundKey: { position: 'absolute', width: '85%', height: '85%', opacity: 0.1 },
  logo: { width: ms(125, 0.3), height: ms(125, 0.3), marginBottom: ms(16) },
  title: { fontSize: ms(24, 0.3), fontWeight: 'bold', color: '#FFFFFF', marginBottom: ms(8), textAlign: 'center' },
  subtitle: { fontSize: ms(16, 0.3), color: '#FFFFFF', textAlign: 'center', opacity: 0.9, lineHeight: ms(22, 0.3) },
  contentContainer: { flex: 1, backgroundColor: '#F3F6F8', borderTopLeftRadius: ms(20), borderTopRightRadius: ms(20), paddingTop: ms(40), alignItems: 'center', paddingHorizontal: ms(20) },
  question: { fontSize: ms(20, 0.3), fontWeight: '600', color: '#1C2C4F', textAlign: 'center', marginBottom: ms(30) },
  buttonContainer: { width: '100%', alignItems: 'center' },
  yesButton: { backgroundColor: '#29BFC0', borderRadius: ms(25), paddingVertical: ms(15), paddingHorizontal: ms(40), alignItems: 'center', marginBottom: ms(15), minWidth: s(250) },
  yesButtonText: { color: '#FFFFFF', fontSize: ms(16, 0.3), fontWeight: '600' },
  noButton: { backgroundColor: '#FF9F64', borderRadius: ms(25), paddingVertical: ms(15), paddingHorizontal: ms(40), alignItems: 'center', minWidth: s(250) },
  noButtonText: { color: '#FFFFFF', fontSize: ms(16, 0.3), fontWeight: '600' },
});
